/* eslint-disable @typescript-eslint/naming-convention */
import { lazy, useEffect, useState } from 'react'
import { Redirect, useParams, useLocation } from 'react-router-dom'
import { Box, Typography } from '@astro-ui/components'
import { getFeatureFlagByLocationID } from 'utils/api'
import { resetOrder } from 'features/Order/redux/OngoingOrders'
import { useAppDispatch } from 'store'
import ForbiddenImage from 'assets/images/astronauts.svg'

const NewOrder = lazy(() => import('../pages/OngoingOrdersV2/NewOrders'))
const BackToHub = lazy(() => import('../pages/OngoingOrdersV2/BackToHubOrders'))
const UpcomingOrders = lazy(() => import('../pages/OngoingOrdersV2/UpcomingOrders'))
const Picking = lazy(() => import('../pages/OngoingOrdersV2/PickingOrders'))
const Packing = lazy(() => import('../pages/OngoingOrdersV2/PackingOrders'))
const OnDelivery = lazy(() => import('../pages/OngoingOrdersV2/OnDeliveryOrders'))
const WaitingDriver = lazy(() => import('../pages/OngoingOrdersV2/WaitingDriver'))
const WaitingKitchen = lazy(() => import('../pages/OngoingOrdersV2/WaitingKitchen'))

const ForbiddenState = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: 'calc(100vh - 200px)' }}
    gap="24px"
  >
    <img src={ForbiddenImage} alt="forbidden" style={{ width: 320 }} />
    <Typography fontSize={16} fontWeight={700} color="#6B7280">
      Lokasi ini masih menggunakan Pesanan Berlangsung V1
    </Typography>
  </Box>
)

const DynamicRouteHandlerV2 = () => {
  const { status } = useParams<{ status: string }>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const locationId = searchParams.get('locationId')

  const dispatch = useAppDispatch()
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null)

  useEffect(() => {
    const checkFeatureFlag = async () => {
      if (!locationId) {
        setIsAllowed(true)
        return
      }
      try {
        const response = await getFeatureFlagByLocationID(locationId, {
          featureKey: 'migrate_pesanan_berlangsung',
        })
        const flag = response?.data?.data?.features?.migrate_pesanan_berlangsung === true
        setIsAllowed(flag)
        if (!flag) dispatch(resetOrder())
      } catch {
        setIsAllowed(false)
        dispatch(resetOrder())
      }
    }
    checkFeatureFlag()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId])

  if (isAllowed === null) return <></>
  if (!isAllowed) return <ForbiddenState />
  if (status === 'waiting-driver' || status === 'ready-for-delivery') {
    return <Redirect to={`/dashboard/ongoing-orders/waiting-for-delivery${location.search}`} />
  }

  const componentMapping: {
    [key: string]:
      | React.LazyExoticComponent<() => JSX.Element>
      | React.LazyExoticComponent<React.MemoExoticComponent<() => JSX.Element>>
  } = {
    'back-to-hub': BackToHub,
    'new-order': NewOrder,
    upcoming: UpcomingOrders,
    picking: Picking,
    packing: Packing,
    'on-delivery': OnDelivery,
    'waiting-for-delivery': WaitingDriver,
    'waiting-kitchen': WaitingKitchen,
  }
  const Component = componentMapping[status]
  if (!Component) return <NewOrder />
  return <Component />
}
export default DynamicRouteHandlerV2
